/** @file mirrorNodeKey: a node key mirrored across x = 0 (yaw and roll negated, x negated, parent twinned). */
import type { NodeKey } from '@zilo/pose3d-format/types/clip';
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';

const neg = (v: number): number => -v + 0;

/** `rot: [wrap(−yaw), pitch, −roll]` (never `-0`), `pos: [−x, y, z]`, `parent → twinOfParent ?? parent`, rest copied. */
export function mirrorNodeKey(key: NodeKey, twinOfParent?: string): NodeKey {
  const out: NodeKey = structuredClone(key);
  if (key.rot !== undefined) out.rot = [wrapDegrees(-key.rot[0]), key.rot[1], neg(key.rot[2])];
  if (key.pos !== undefined) out.pos = [neg(key.pos[0]), key.pos[1], key.pos[2]];
  if (typeof key.parent === 'string' && twinOfParent !== undefined) out.parent = twinOfParent;
  return out;
}
